if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.isVerticalScroll = this.classList.contains('vertical-scroll') && window.innerWidth >= 1025 && !this.closest('.quick-add-modal');

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.isVerticalScroll) this.removeListSemantic();

        // Initialize thumbnail slider scroll functionality
        this.initThumbnailSlider();

        // Hook up overlay arrows on main media to existing slider controls
        this.initMediaOverlayArrows();

        // Ensure clicking main media still opens zoom/modal
        this.initMediaZoomDelegation();
      }

      initMediaOverlayArrows() {
        if (!this.elements.viewer || !this.elements.thumbnails) return;

        const thumbnailSlider = this.elements.thumbnails;
        const thumbnailItems = Array.from(thumbnailSlider.querySelectorAll('[data-target]'));

        if (thumbnailItems.length <= 1) return;

        const clickRelativeThumbnail = (direction) => {
          const currentButton = thumbnailSlider.querySelector('.thumbnail[aria-current="true"]');
          if (!currentButton) return;

          const currentItem = currentButton.closest('[data-target]');
          if (!currentItem) return;

          const items = thumbnailItems;
          const currentIndex = items.indexOf(currentItem);
          const safeIndex = currentIndex === -1 ? 0 : currentIndex;

          let nextIndex = safeIndex + direction;
          if (nextIndex < 0) {
            nextIndex = items.length - 1;
          } else if (nextIndex >= items.length) {
            nextIndex = 0;
          }

          const targetItem = items[nextIndex];
          const targetButton = targetItem.querySelector('button');
          if (targetButton) {
            targetButton.click();
          }
        };

        this.elements.viewer.querySelectorAll('[data-media-id] .product__media-arrow').forEach((arrow) => {
          const action = arrow.dataset.mediaArrow;
          if (action === 'prev') {
            arrow.addEventListener('click', (event) => {
              event.stopPropagation();
              clickRelativeThumbnail(-1);
            });
          } else if (action === 'next') {
            arrow.addEventListener('click', (event) => {
              event.stopPropagation();
              clickRelativeThumbnail(1);
            });
          }
        });
      }

initMediaZoomDelegation() {
  if (!this.elements.viewer) return;
  
  this.elements.viewer.addEventListener('click', (event) => {
    // 检查点击的是否是媒体项
    const mediaItem = event.target.closest('.product__media-item');
    if (!mediaItem) return;
    
    // 检查是否点击的是箭头
    if (event.target.closest('.product__media-arrow')) return;
    
    // 找到modal-opener元素
    const modalOpener = mediaItem.querySelector('modal-opener');
    if (!modalOpener) return;
    
    // 找到modal-opener内部的按钮并触发点击
    const button = modalOpener.querySelector('button');
    if (button) {
      console.log('触发modal-opener按钮点击');
      button.click();
    }
  });
}

      initThumbnailSlider() {
        const thumbnailSlider = this.elements.thumbnails;
        if (!thumbnailSlider || !thumbnailSlider.classList.contains('thumbnail-slider--scrollable')) return;

        const thumbnailList = thumbnailSlider.querySelector('.thumbnail-list');
        const nextBtn = thumbnailSlider.querySelector('.thumbnail-slider__next-btn');
        const prevBtn = thumbnailSlider.querySelector('.thumbnail-slider__prev-btn');

        if (!thumbnailList) return;

        const scrollAmount = 118 + 16; // thumbnail width + gap

        // Handle next button click
        if (nextBtn) {
          nextBtn.addEventListener('click', () => {
            thumbnailList.scrollBy({ left: scrollAmount * 2, behavior: 'smooth' });
          });
        }

        // Handle previous button click
        if (prevBtn) {
          prevBtn.addEventListener('click', () => {
            thumbnailList.scrollBy({ left: -scrollAmount * 2, behavior: 'smooth' });
          });
        }

        // Check scroll position and update button visibility (both sides)
        const updateButtonsVisibility = () => {
          const isAtStart = thumbnailList.scrollLeft <= 10;
          const isAtEnd = thumbnailList.scrollLeft + thumbnailList.clientWidth >= thumbnailList.scrollWidth - 10;

          if (prevBtn) {
            prevBtn.classList.toggle('hidden', isAtStart);
          }
          if (nextBtn) {
            nextBtn.classList.toggle('hidden', isAtEnd);
          }

          thumbnailList.classList.toggle('scrolled-to-end', isAtEnd);
        };

        thumbnailList.addEventListener('scroll', updateButtonsVisibility);
        updateButtonsVisibility();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) || this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) {
          return;
        }

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (this.isVerticalScroll) {
            activeMedia.parentElement.scrollTo({ top: activeMedia.offsetTop });
          } else {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (!activeThumbnail) return;
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail.dataset && activeThumbnail.dataset.mediaPosition) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
          
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        if (this.isVerticalScroll) {
          this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
        } else {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();

        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}